import React, { ReactNode } from "react";
// External dependencies
import classNames from "classnames";

// Define prop types for WrapperSubHeader
interface WrapperSubHeaderProps {
  className?: string;
  subClassName?: string;
  children?: ReactNode;
}

const WrapperSubHeader: React.FC<WrapperSubHeaderProps> = ({ className, subClassName, children }) => {
  // Combining default and additional classes for the main classes
  const mainClasses = classNames("m-subheader", className);
  // Combining default and additional classes for the sub classes
  const subClasses = classNames("d-flex align-items-center", subClassName);
  
  return (
    <div className={mainClasses}>
      <div className={subClasses}>{children}</div>
    </div>
  );
};

export default WrapperSubHeader;
